export default __webpack_public_path__ + "5a9b03182a542a3fd63b33d58213509b.jpg";